module.exports = __webpack_public_path__ + "static/media/google-wallet.e0521632.svg";